export const buttonParams = {
  check: {
    text: 'Проверить',
    classes: 'ml-2 mb-2 card-button_action',
  },
  showAnswer: {
    text: 'Показать ответ',
    classes: 'ml-2 mb-2 card-button_action',
  },
  delete: {
    text: 'Удалить',
    classes: 'ml-2 mb-2 card-button_action',
  },
  markAsHard: {
    text: 'Сложно',
    classes: 'ml-2 mb-2 card-button_mark',
  },
  markAsGood: {
    text: 'Хорошо',
    classes: 'ml-2 mb-2 card-button_mark',
  },
  markAsEasy: {
    text: 'Легко',
    classes: 'ml-2 mb-2 card-button_mark',
  },
  learnAgain: {
    text: 'Снова',
    classes: 'ml-2 mb-2 card-button_mark',
  },
};
